package com.cybersoftsolution.cybersoftsolutionweb.components.buttons

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.styles.PrimaryButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.primaryButtonId
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button

@Composable
fun LoginButton(onClick: () -> Unit = {}){
    Button(

        attrs = PrimaryButtonStyle.toModifier()
            .id(primaryButtonId)
            .backgroundColor(Theme.PrimaryButton.rgb)
            .width(350.px)
            .height(54.px)
            .padding(leftRight = 24.px)
            .margin(bottom = 12.px)
            .borderRadius(10.px)
//            .border(
//                width = 1.px,
//                style = LineStyle.Outset,
//                color = Theme.Primary.rgb
//            )
            .fontWeight(FontWeight.Medium)
            .fontSize(FontSize.Large)
            .cursor(Cursor.Pointer)
            .onClick { onClick() }
            .toAttrs(),


        ){
        SpanText(
            text = "Iniciar Sesión",
            modifier = Modifier
                .color(Colors.Black)

        )
    }
}